import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBServiceIsConnectionRequestPending } from 'pages/Internet/store/selectors/servicesSelectors';
import {
  getFTTBServiceConnectionDate,
  getFTTBServiceIsBlocked,
  getFTTBServiceRequestId,
} from 'pages/Internet/store/selectors';
import { cancelFutureRequest } from 'pages/Internet/store/actions';
import { ConnectionDateStatus } from 'pages/Internet/components/ServiceBlock/components';

export const ServiceConnectionRequestStatus = compose(
  connect(
    (state) => ({
      isAllowed: !getFTTBServiceIsBlocked(state),
      namePath: 'internet.messages.connectionDate',
      linkText: 'Не подключать',
      changeRequestId: getFTTBServiceRequestId(state),
      date: getFTTBServiceConnectionDate(state),
      shouldRender: !!getFTTBServiceIsConnectionRequestPending(state),
    }), { cancelFutureRequest },
  ), withRenderFlag,
)(ConnectionDateStatus);
